import { Entity } from './Entity';

export class Projectile implements Entity {
  public x: number;
  public y: number;
  public width: number;
  public height: number;
  public active: boolean = true;

  private speed: number;
  private damage: number;
  private color: string;
  private piercing: boolean;
  private friendly: boolean; // true = player bullet, false = enemy bullet

  constructor(x: number, y: number, speed: number, friendly: boolean = true, piercing: boolean = false) {
    this.x = x;
    this.y = y;
    this.width = 4;
    this.height = 12;
    this.speed = speed;
    this.damage = 1;
    this.friendly = friendly;
    this.piercing = piercing;
    this.color = friendly ? '#00ffff' : '#ff0000';
  }

  public update(deltaTime: number): void {
    // Move bullet
    if (this.friendly) {
      this.y -= this.speed * deltaTime * 60; // Move up
    } else {
      this.y += this.speed * deltaTime * 60; // Move down
    }

    // Deactivate if off screen
    if (this.y < -this.height || this.y > 960) {
      this.active = false;
    }
  }

  public render(ctx: CanvasRenderingContext2D): void {
    ctx.fillStyle = this.color;
    
    if (this.piercing) {
      // Draw piercing bullet with glow
      ctx.shadowBlur = 10;
      ctx.shadowColor = this.color;
    }
    
    ctx.fillRect(
      this.x - this.width / 2,
      this.y - this.height / 2,
      this.width,
      this.height
    );
    
    if (this.piercing) {
      ctx.shadowBlur = 0;
    }
  }

  public getBounds(): { x: number; y: number; width: number; height: number } {
    return {
      x: this.x - this.width / 2,
      y: this.y - this.height / 2,
      width: this.width,
      height: this.height,
    };
  }

  public getDamage(): number {
    return this.damage;
  }

  public setDamage(damage: number): void {
    this.damage = damage;
  }

  public isPiercing(): boolean {
    return this.piercing;
  }

  public isFriendly(): boolean {
    return this.friendly;
  }

  public getColor(): string {
    return this.color;
  }

  public deactivate(): void {
    if (!this.piercing) {
      this.active = false;
    }
  }
}
